import { Card, Table } from "antd";
import React, { useEffect, useRef } from "react";
import { DndProvider, useDrag, useDrop } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";



export default function PublisherRow(props) {
    const {
        id = "",
        item = {},
        type = "publisher",
        accept = "",
        onDrop = () => { },
        dragging = false,
        className = "",
        setDragging = () => { },
        can_drag = true, // New parameter
    } = props;

    const [{ isDragging }, dragRef] = useDrag(
        () => ({
            type,
            item: { id, item, type },
            canDrag: can_drag,
            collect: (monitor) => ({
                isDragging: monitor.isDragging(),
            }),
        }),
        [id, item, type, can_drag] // ✅ ensure fresh item each render
    );

    const [{ isOver }, dropRef] = useDrop(() => ({
        accept: accept,
        drop: (item) => onDrop(item, id),
        collect: (monitor) => ({
            isOver: monitor.isOver(),
        }),
    }));

    useEffect(() => {
        // Update dragging state if necessary
        if (isDragging) {
            setDragging(type)
        } else {
            setDragging("")
        }
    }, [isDragging, setDragging]);

    return (
        <div
            key={item.id}
            className={className}
            ref={(node) => can_drag ? dragRef(dropRef(node)) : dropRef(node)} // Conditional application of dragRef
            style={{
                filter: (isOver) ? "hue-rotate(180deg)" : "hue-rotate(0deg)",
                padding: "0px 0px",
                cursor: can_drag ? "grab" : "pointer", // Adjust cursor based on can_drag
            }}
        >
            {/* {isDragging.toString()} */}
            {/* {isOver.toString()}
            {accept} */}
            {props.children}
        </div>
    );
}
